import "../App.css";
import NumberOfMentions from "../components/NumberOfMentions";
import BestSources from "../components/BestSources";
import PublicTop from "../components/PubicTop";
import Metrics from "../components/Metrics";
import MediaIndex from "../components/MediaIndex";
import Calendar from "../components/Calendar";
import { useAppDispatch } from "../redux/store/hooks";
import {
  logoutAuth,
  resetFeedFilter,
  setProduct,
  setProducts,
  setReferences,
  setReferencesFilter,
} from "../redux/actions";
import { useEffect } from "react";
import { referencesService } from "../api";
import { useSelector } from "react-redux";
import {
  getMainProduct,
  getProduct,
  getReferences,
  getReferencesFilter,
} from "../redux/selectors";

function Districts() {
  const dispatch = useAppDispatch();
  dispatch(resetFeedFilter());
  const mainProduct = useSelector(getMainProduct);
  const product = useSelector(getProduct);
  const referencesFilter = useSelector(getReferencesFilter);
  const references = useSelector(getReferences);

  useEffect(() => {
    referencesService
      .loadClientProducts()
      .then((resp) => {
        if (
          product == null ||
          product == mainProduct?.id ||
          referencesFilter[0] == mainProduct?.client?.id ||
          references[0] == mainProduct?.client?.id
        ) {
          dispatch(setProduct(resp[0]?.id));
          dispatch(setReferencesFilter([resp[0]?.client?.id]));
          dispatch(setReferences([resp[0]?.client?.id]));
        }
        dispatch(setProducts(resp));
      })
      .catch((err) => {
        dispatch(logoutAuth());
      });
  }, []);

  return (
    <div className="App">
      <h1>
        {window.location.pathname.includes("main")
          ? mainProduct?.client?.title
          : "Районы"}
      </h1>
      <Calendar />
      <NumberOfMentions />
      {/*<TonalStatistic />*/}
      <MediaIndex />
      <BestSources />
      <PublicTop />
      {/*<BestThemes />*/}
      <Metrics />
    </div>
  );
}

export default Districts;
